import React from "react"
import { Switch, Route } from "react-router-dom"
import { Redirect } from "react-router"
// import Error404 from "./Error404";

import Home from "./Home"
import UpcomingTractors from "./UpcomingTractors"
import TractorDetailed from './ProducDetailed/TractorDetailed'

const Routes = () => (
  <main>
    <Switch>
        <Route exact path="/"><Home /></Route>
        <Route path="/upcoming-tractors"><UpcomingTractors /></Route>
        <Route path="/tractors/:type/:productId"><TractorDetailed /></Route>

        
        <Redirect from="*" to="/page-not-found" />
    </Switch>
  </main>
);

export default Routes;